// ThemeToggleButton.tsx
import { IconButton, Tooltip } from "@mui/material";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
// import { useTheme } from "@mui/material/styles";
import { useColorMode } from "../contexts/ColorModeProvider";
// import { useEffect } from "react";

export default function ThemeToggleButton() {
    // const theme = useTheme();
    const { toggleColorMode, mode } = useColorMode();

    const isDark = mode === "dark";

    // console.log("Render: ThemeToggleButton: isDark = " + isDark);
    // console.log("Render: Current theme mode:", mode);

    // useEffect(() => {
    //     console.log("Effect: ThemeToggleButton: isDark = " + isDark);
    //     console.log("Effect: Current theme mode:", theme.palette.mode);
    // }, [isDark]);

    return (
        <Tooltip title={`Switch to ${isDark ? "light" : "dark"} mode`}>
            <IconButton
                onClick={toggleColorMode}
                color="inherit"
                sx={{
                    fontSize: 28,
                    py: 0.25,
                    pl: 0.75,
                    pr: 0,
                    '&:hover': {
                        bgcolor: 'transparent',
                        color: 'rgba(250, 204, 21, 0.96)',
                    },
                }}
            >
                {isDark ? <LightModeIcon /> : <DarkModeIcon />}
            </IconButton>
        </Tooltip>
    );
}
